export default __webpack_public_path__ + "static/media/fifteen.f1f09fec.jpeg";